import { ReduxState, Wallet as IWallet, WalletActions } from 'interfaces';
import React, { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { walletPageData } from './wallet.data';
import MyWallet from './myWallet/myWallet.index';
import { Withdrawal } from './withdrawal/withdrawal.index';
import Deposit from './deposit/deposit.index';
import { getWallet } from './wallet.service';
import { useNavigate, useParams } from 'react-router-dom';
import { SyncOutlined } from '@ant-design/icons';
import { get, post } from 'scripts';
import { API } from 'data/30pay.api';
import { toast } from 'react-toastify';
import { Alert, Countdown } from '30pay/components';

const stringToActionMap: Record<string, WalletActions> = {
    mine: WalletActions.Mine,
    deposit: WalletActions.Deposit,
    withdrawal: WalletActions.Withdrawal,
};

const actionToStringMap: Record<WalletActions, string> = {
    [WalletActions.Mine]: 'mine',
    [WalletActions.Deposit]: 'deposit',
    [WalletActions.Withdrawal]: 'withdrawal',
};

const Wallet: React.FC<ConnectedProps<typeof connector>> = (props) => {
    const [wallet, setWallet] = useState<IWallet>();
    const [hideBalances, setHideBalances] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [syncLoading, setSyncLoading] = useState(false);

    const { action: actionParam } = useParams<{ action?: string }>();
    const navigate = useNavigate();

    const action: WalletActions =
        actionParam && stringToActionMap[actionParam.toLowerCase()]
            ? stringToActionMap[actionParam.toLowerCase()]
            : WalletActions.Mine;

    const renderAction = (action: WalletActions) => {
        switch (action) {
            case WalletActions.Mine:
                return <MyWallet {...{ wallet, hideBalances, setHideBalances, loading }} />;
            case WalletActions.Deposit:
                return <Deposit {...{ wallet, hideBalances, setHideBalances }} />;
            case WalletActions.Withdrawal:
                return <Withdrawal {...{ wallet, hideBalances, setHideBalances }} />;
            default:
                return <></>;
        }
    };

    useEffect(() => {
        getWallet(setLoading, setWallet);
    }, []);

    function refresh() {
        setSyncLoading(true);
        post(API.wallet.sync, {})
            .then((e) => {
                toast.success(e.value.message);
                getWallet(setLoading, setWallet);
            })
            .catch((err) => console.error(err))
            .finally(() => setSyncLoading(false));
    }

    return (
        <div className="p-4 flex flex-col">
            {wallet?.withdrawalDisableTill && !wallet.withdrawalEnable ? (
                <Alert
                    variant="warning"
                    className="mb-6"
                    message={
                        <div className="flex justify-between items-center">
                            <span className="text-sm font-medium text-black-100">
                                کاربر گرامی، با توجه به قانون پلیس فتا، اولین تراکنش شما پس از ۷۲ ساعت انجام میشود.
                            </span>
                            <Countdown value={wallet?.withdrawalDisableTill} />
                        </div>
                    }
                />
            ) : null}
            <div className="flex items-center gap-4">
                {walletPageData?.map((item) => (
                    <div
                        key={item.action}
                        onClick={() => navigate(`/wallet/${actionToStringMap[item.action]}`)}
                        className={`flex items-center gap-1 rounded-[20px] px-4 !h-10 clickable !transition-all ${
                            action === item.action ? 'bg-primary-100 text-white' : 'bg-white text-black-100'
                        }`}
                    >
                        <img src={action === item.action ? item.iconFill : item.icon} alt="wallet" />
                        <label className="clickable font-medium text-base max-lg:text-xs">{item.label}</label>
                    </div>
                ))}
                <div className="flex items-center gap-2">
                    <SyncOutlined spin={syncLoading} onClick={refresh} />
                </div>
            </div>
            {renderAction(action)}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(Wallet);
